import { render, staticRenderFns } from "./coti.vue?vue&type=template&id=5ef5da60&scoped=true"
import script from "./coti.vue?vue&type=script&lang=js"
export * from "./coti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef5da60",
  null
  
)

export default component.exports